import React from 'react'
import TextInput, { TextInputProps } from './text-input.component'

export const DateInput = ({ type, ...rest }: TextInputProps) => {
    return <TextInput type="date" {...rest} />
}
